export const reconciliationRegex = /^\/accountings\/\d+\/reconciliation/;